export default __webpack_public_path__ + "static/media/mw_logo.fdfbba35.png";